async function prefetchQueryIfNeeded(queryClient, query) {
  const dataState = queryClient.getQueryState(query.queryKey);
  if ((dataState == null ? void 0 : dataState.status) !== "success") {
    await queryClient.prefetchQuery(query);
  }
}

export { prefetchQueryIfNeeded };
//# sourceMappingURL=tanstack.prefetch-if-missing.js.map
